export function createPageData(data) {  
  return {
    pagePath: data.Page_Path,
    title: data.Meta_Title,
    description: data.Meta_Description,
    canonical: `https://www.dish.com/availability${data.Page_Path}`,
    robots: 'index, follow',
    promoCode: data.Promo_Code,
  }
}
